import { render, staticRenderFns } from "./BulkMailer.vue?vue&type=template&id=6cb543bb&"
import script from "./BulkMailer.vue?vue&type=script&lang=js&"
export * from "./BulkMailer.vue?vue&type=script&lang=js&"
import style0 from "./BulkMailer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports